import { Link, useParams, useNavigate } from 'react-router-dom';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import apiMethod from '../../../services/api-service';
import Preloading from '../../../components/basics/Preloading';

// assets
import clipboard from "../../../assets/images/icons/clipboard-tick.svg";
import chefhat from "../../../assets/images/icons/chef's hat.svg";
import note from "../../../assets/images/icons/note.svg";
import table from "../../../assets/images/icons/table_84011 (1) 1.svg"
import delivery from "../../../assets/images/icons/delivery.svg";
import people from "../../../assets/images/icons/people.svg";
import house from "../../../assets/images/icons/house-2.svg";
import food from "../../../assets/images/icons/food.svg";
import buildings from "../../../assets/images/icons/buildings.svg";
import send from "../../../assets/images/icons/send-2.svg";
import printer from "../../../assets/images/icons/printer.svg";
import cpu from "../../../assets/images/icons/cpu-setting.svg";
import back from "../../../assets/images/icons/arrow-right2.svg";
import monitor from "../../../assets/images/icons/monitor.svg";
import mirroring from "../../../assets/images/icons/mirroring-screen.svg";
import cardpos from "../../../assets/images/icons/card-pos.svg";
import calculator from "../../../assets/images/icons/calculator.svg"
import car from "../../../assets/images/icons/car.svg"

const DashboardMenus = () => {
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const { branchId } = useParams();
  const [branchOrderCounts, setBranchOrderCounts] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [resurantId , setResturantId] = useState(null)
  const navigate = useNavigate();
  const [accesses, setAccesses] = useState({
    order: false,
    employee: false,
    devices: false,
    sales: false,
    settings: false
  });

  const tabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    navigate(`/sale/${branchId}/#${tabNumber}`);
  };

  async function bindBaseData() {
    const branchInfoResp = await apiMethod.getBranchInfo(branchId);
    const branchOrderCountsResp = await apiMethod.getBranchOrderCounts(branchId);
    setResturantId(branchInfoResp.data.restaurantId)
    if (methods.showApiErrors(branchInfoResp)) setTitle(branchInfoResp.data.title);
    if (methods.showApiErrors(branchOrderCountsResp)) setBranchOrderCounts(branchOrderCountsResp.data);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        checkAccesses();
        await bindBaseData();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [branchId]);

  useEffect(() => {
    const tabNumber = parseInt(window.location.hash.replace("#", ""), 10);
    if (!isNaN(tabNumber) && tabNumber > 0 && tabNumber <= 5) {
      setActiveTab(tabNumber);
    }
  }, []);

  const checkAccesses = () => {
    const roles = methods.getUserRoles();
    if (roles.some(x => x.name === "SaleAdmin")) {
      accesses.order = true;
      accesses.devices = true;
      accesses.sales = true;
      accesses.employee = true;
      accesses.settings = true;
    }

    if (roles.some(x => x.name === "Cashier")) {
      accesses.order = true;
      accesses.devices = true;
    }

    setAccesses({ ...accesses });
  }

  const renderMain = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/${resurantId}/dashboard`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to="/dashboard" className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                {title}
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="salemain">
              <div className='d-none d-lg-block'>
                <div className='detaileheader'>
                  <div className='d-flex align-items-baseline '>
                    <div className='d-flex d-lg-none justify-content-start align-items-baseline '>
                      <Link to="/dashboard" className='link back-link me-1'>
                        <span><img src={back} className="" alt="return" /></span>
                      </Link>
                    </div>
                    <p className='branchname'>{title}</p>
                  </div>
                  <p className="date d-block d-lg-none">{methods.currentDate()}</p>
                </div>
              </div>
              <div>
                <ul className="nav nav-underline my-3 flex-nowrap overflow-auto" id="myTabs">
                  {accesses.order &&
                    <li className="nav-item">
                      <a className={`nav-link ${activeTab === 1 ? 'active' : ''}`} id="tab1" onClick={() => tabClick(1)} data-bs-toggle="tab" href="#content1">بخش سفارش ها</a>
                    </li>
                  }
                  {accesses.employee &&
                    <li className="nav-item">
                      <a className={`nav-link ${activeTab === 2 ? 'active' : ''}`} id="tab2" onClick={() => tabClick(2)} data-bs-toggle="tab" href="#content2">مدیریت کارمندان</a>
                    </li>
                  }
                  {accesses.devices &&
                    <li className="nav-item">
                      <a className={`nav-link ${activeTab === 3 ? 'active' : ''}`} id="tab3" onClick={() => tabClick(3)} data-bs-toggle="tab" href="#content3">دستگاه و صندوق</a>
                    </li>
                  }

                  {accesses.sales &&
                    <li className="nav-item">
                      <a className={`nav-link ${activeTab === 4 ? 'active' : ''}`} id="tab4" onClick={() => tabClick(4)} data-bs-toggle="tab" href="#content4">مدیریت فروش</a>
                    </li>
                  }

                  {accesses.settings &&
                    <li className="nav-item">
                      <a className={`nav-link ${activeTab === 5 ? 'active' : ''}`} id="tab5" onClick={() => tabClick(5)} data-bs-toggle="tab" href="#content5">تنظیمات</a>
                    </li>
                  }
                </ul>
                <div className="tab-content">
                  <div className={`tab-pane fade ${activeTab === 1 ? 'show active' : ''}`} id="content1">
                    <div className="row row-cols-1 row-cols-lg-3 g-4">
                      <div className="col">
                        <div className="card branchcardtabs">
                          <img src={clipboard} className="branchtabicon" alt="recordorder" />
                          <span className="badge sidebar-badge rounded-pill badge-top-left">{branchOrderCounts.currentOrderCount}</span>
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/submitOrder/0`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100" data-toggle="hover-effect">
                                ثبت سفارش
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs">
                          <img src={clipboard} className="branchtabicon" alt="recordorder" />
                          <span className="badge sidebar-badge rounded-pill badge-top-left">{branchOrderCounts.snappOrderCount}</span>
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/snappManager/Orders/0`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100" data-toggle="hover-effect">
                                ثبت سفارش اسنپ
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={note} className="branchtabicon" alt="mangeorder" />
                          <span className="badge sidebar-badge rounded-pill badge-top-left">{branchOrderCounts.allOrderCount}</span>
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/orderManagment`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                مدیریت سفارش‌ها
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={chefhat} className="branchtabicon" alt="kitchenlist" />
                          <span className="badge sidebar-badge rounded-pill badge-top-left">{branchOrderCounts.kitchenOrderCount}</span>
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/kitchenList`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                لیست آشپزخانه
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={car} className="branchtabicon" alt="car" />
                          <span className="badge sidebar-badge rounded-pill badge-top-left">{branchOrderCounts.deliveredOrderCount}</span>
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/deliveryOrder`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                تحویل سفارش
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 2 ? 'show active' : ''}`} id="content2">
                    <div className="row row-cols-1 row-cols-lg-3 g-4">
                      <div className="col">
                        <div className="card branchcardtabs">
                          <img src={people} className="branchtabicon" alt="branchemployee" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/employee`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                کارمندان شعبه
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={delivery} className="branchtabicon" alt="delivery" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/deliverySettlement`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                مدیریت پیک ها
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 3 ? 'show active' : ''}`} id="content3">
                    <div className="row row-cols-1 row-cols-lg-3 g-4">
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={monitor} className="branchtabicon" alt="Daily warehouse" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/cashDeskManage`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                صندوق‌های شعبه
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={mirroring} className="branchtabicon" alt="Sales departments" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/posDevices`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                دستگاه پوز
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={cardpos} className="branchtabicon" alt="salesmenu" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/pager`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                پیجر
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={printer} className="branchtabicon" alt="kitchenlist" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/printer`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                تتظیمات پرینتر
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={table} className="branchtabicon" alt="table" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/diningtable`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                میز غذاخوری
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 4 ? 'show active' : ''}`} id="content4">
                    <div className="row row-cols-1 row-cols-lg-3 g-4">
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={house} className="branchtabicon" alt="Daily warehouse" />
                          <div className="card-body">
                            <Link to="#">
                              <button type="button" className="btn custome-btn btn-link-purple w-100">
                                انبار روزانه فروش
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={buildings} className="branchtabicon" alt="Sales departments" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/saleunits`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                بخش های فروش
                              </button>
                            </Link>

                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={food} className="branchtabicon" alt="salesmenu" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/selectUnit`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                منوهای فروش
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 5 ? 'show active' : ''}`} id="content5">
                    <div className="row row-cols-1 row-cols-lg-3 g-4">
                      <div className="col">
                        <div className="card branchcardtabs">
                          <img src={clipboard} className="branchtabicon" alt="snapsettings" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/snappManager`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100" data-toggle="hover-effect">
                                تتظیمات اسنپ
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={send} className="branchtabicon" alt="mangeorder" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/shipmentManger`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                تنظیمات ارسال
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={cpu} className="branchtabicon" alt="table" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/branchSetting`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                تنظیمات پایه
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <img src={calculator} className="branchtabicon" alt="table" />
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/serviceSetting`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                تعریف خدمات
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <i className="bi bi-telephone-forward fs-1 branchtabicon"></i>
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/callCenter`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                مرکز تماس‌ها
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card branchcardtabs" >
                          <i className="bi bi-wallet2 fs-1 branchtabicon"></i>
                          <div className="card-body">
                            <Link to={`/sale/${branchId}/merchantWallet`}>
                              <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                مدیریت مشتریان
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      </>
    )
  };

  return (
    <>
      {renderMain()}
    </>
  );
}

export default DashboardMenus;